import styled from 'styled-components'

const BoardBackground = styled.div`
  flex: 1 1;
  display: flex;
  overflow: hidden;
`

export default BoardBackground
